import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Center,
  Stack,
  Text,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { AiFillEye } from "react-icons/ai";
import { BsFillPersonCheckFill, BsFillStarFill } from "react-icons/bs";
import { PiTreeStructureFill } from "react-icons/pi";
import { useContaxt } from "../../context/Context";
import { ActionButton } from "../ActionButton";
import { HeadLine } from "../HeadLine";

export function Advantege() {
  const { color, marginTop } = useContaxt();

  const infos = [
    {
      icon: <BsFillPersonCheckFill size={72} color={color.mainColor} />,
      title: "System",
      text: "Mit einer Website lassen sich systematisch neue Kunden gewinnen. Sie ist 24 / 7 für dich im Einsatz.",
    },
    {
      icon: <BsFillStarFill size={72} color={color.mainColor} />,
      title: "Professionalität",
      text: "Mit einer eigenen Website wird dein Unternehmen von potenziellen Kunden und Geschäftspartnern als professioneller wahrgenommen.",
    },
    {
      bgColor: color.mainColor,
      icon: <AiFillEye size={72} color={"white"} />,
      color: "white",
      title: "Überblick",
      text: "Eine professionell gestaltete und gut strukturierte Website ermöglicht den Besuchern einen schnellen Überblick über alle wichtigen Informationen zu deinem Angebot.",
    },
    {
      icon: <PiTreeStructureFill size={72} color={"white"} />,
      color: "white",
      bgColor: "black",
      title: "Struktur",
      text: "Die richtige Struktur der Website hilft, die Ziele der Website zu erreichen. Je nach Zielsetzung wählen wir die optimale Struktur aus und setzen diese um.",
    },
  ];

  return (
    <>
      <Box w={"100%"}>
        <HeadLine
          as="h1"
          text={
            <Text>
              Welche <b>Vorteile</b> eine professionelle <b>Webseite</b> für
              dich hat
            </Text>
          }
        />
        <Stack>
          <Center w={"100%"}>
            <Wrap mt={marginTop} px={3} justify={"center"} spacing={10}>
              {infos.map((info, i) => {
                return (
                  <WrapItem key={i}>
                    <Card
                      border={`2px solid ${
                        info.bgColor !== "black" ? "#D29F68" : "black"
                      }`}
                      bgColor={info.bgColor ? info.bgColor : "white"}
                      color={info.color ? info.color : "#1A202C"}
                      rounded="md"
                      h={["xx", "xx", "400px", "400px"]}
                      w={["90vw", "90vw", "250px", "250px"]}
                    >
                      <CardHeader>
                        <Center>
                          <Stack>
                            <Center w={"100%"}>{info.icon}</Center>

                            <Text
                              fontSize={"20px"}
                              fontWeight={"bold"}
                              color={info.color ? info.color : "black"}
                              mt={"10px"}
                            >
                              {info.title}
                            </Text>
                          </Stack>
                        </Center>
                      </CardHeader>
                      <CardBody mt={"-20px"}>
                        <Center textAlign={"center"}>
                          <Text fontSize={"16px"}>{info.text}</Text>
                        </Center>
                      </CardBody>
                    </Card>
                  </WrapItem>
                );
              })}
            </Wrap>
          </Center>
          <Center mt={marginTop}>
            <ActionButton ml={0} />
          </Center>
        </Stack>
      </Box>
    </>
  );
}
